import { render, staticRenderFns } from "./MoreJoy.vue?vue&type=template&id=5af531db&scoped=true"
import script from "./MoreJoy.vue?vue&type=script&lang=js"
export * from "./MoreJoy.vue?vue&type=script&lang=js"
import style0 from "./MoreJoy.vue?vue&type=style&index=0&id=5af531db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af531db",
  null
  
)

export default component.exports